import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable'
import { environment } from 'environments/environment';

@Injectable()
export class systemCodeConstraintService {

    constructor(private _http: HttpClient) {
    }

    get = (): Observable<any[]> => {
        return this._http.get<any>(`${environment.core}/GroupCodeConstraints`);
    }

    add = (data: any): Observable<any> => {
        return this._http.post<any>(`${environment.core}/GroupCodeConstraints`, data);
    }

    update = (data: any): Observable<any> => {
        return this._http.put<any>(`${environment.core}/GroupCodeConstraints`, data);
    }

    getById = (id: number): Observable<any> => {
        return this._http.get<any>(`${environment.core}/GroupCodeConstraints?codeID=${id}`);
    }

    // delete = (id: number): Observable<any> => {
    //     return this._http.delete<any>(`${environment.core}/GroupCodeConstraints?id=${id}`);
    // }

}
